import { LoggedInDetails } from "../../dtos/login/LoggedInDetails";
import instance from "../../utils/BaseService";

const header = {
  tenantId: localStorage.getItem("tenantId")
}
export interface RefreshTokenProps {
  refreshToken: string;
}
export const loginApi = (credentials: LoggedInDetails) => instance.post("/Authentication/login", credentials);
export const refreshTokeApi = (input:{rememberMe:boolean}) => instance.post(
  "/Authentication/refreshAccessToken", input, { withCredentials: true }) // browser sends HttpOnly cookie automatically);
export const microsoftLogin = (credentials: any) => instance.post("Authentication/microsoftLogin", credentials, {
  headers: header
});